
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/vwo",
      function () {
        return require("private-next-pages/destinations/vwo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/vwo"])
      });
    }
  